/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 10/15/2019
 *
 */

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {Route, HashRouter} from "react-router-dom";
import '../node_modules/font-awesome/css/font-awesome.min.css';

const app = (
    <HashRouter>
        <Route path="/" component={App}/>
    </HashRouter>
);
ReactDOM.render(app, document.getElementById('root'));
